// extracted by mini-css-extract-plugin
export default {"container":"ElectricityTab_container__7HUty"};